<template src="./index.html" />

<script>
import * as XLSX from 'xlsx'
import {
  BBreadcrumb, BButton, BFormFile, BCard, BCol, BContainer, BFormSelect, BOverlay, BPagination, BRow, BFormCheckbox, BFormRadio,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { showErrorToast, showSuccessToast, showWarningToast, showInfoToast } from '@/utils/notification'
import '@core/scss/vue/libs/vue-good-table.scss'
import { mapActions, mapGetters } from 'vuex'
import { Workbook } from '@syncfusion/ej2-excel-export'
import { getUser } from '@/auth/utils'
import { handleCatch, hasPermissionForResource, isSystemAdmin } from '@/utils'
import { ApiCode } from '@/const/api'
import { PermissionCode, ResourceCode } from '@/const/code'

export default {
  name: 'Index',
  components: {
    BBreadcrumb,
    BButton,
    BFormFile,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    XLSX,
    VueGoodTable,
    BFormCheckbox,
    BFormRadio,
  },
  props: {

  },
  data() {
    return {
      user: getUser(),
      itemsBC: [
        {
          text: 'Admin',
          href: '#',
        },
        {
          text: 'Student Management',
          href: '#',
        },
        {
          text: 'Import Student',
          active: true,
        },
      ],
      table: {
        fields: [
          {
            field: 'stt', label: 'STT', sortable: false, type: 'string',
          },
          {
            field: 'name', label: 'Tên cán bộ', sortable: false, type: 'string',
          },
          {
            field: 'account', label: 'Tài khoản', sortable: false, type: 'string',
          },
          {
            field: 'email', label: 'Email', sortable: false, type: 'string',
          },
          {
            field: 'phone', label: 'Số điện thoại', sortable: false, type: 'string',
          },
          {
            field: 'department', label: 'Khoa/Bộ môn', sortable: false, type: 'string',
          },
          {
            field: 'isTeacher', label: 'Là giảng viên', sortable: false, type: 'string',
          },
        ],
        items: [],
      },
      tenFile: '',
      dataExcel: [],
      totalRecords: 0,
      serverParams: {
        page: 1,
        perPage: 10,
      },
      loading: false,
      selected: '',
      disCreateAccount: false,
    }
  },
  computed: {
    ...mapGetters({
      total: 'rooms/total',
    }),
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.IMPORT_EMPLOYEE)
    },
  },
  methods: {
    ...mapActions({
      importEmployee: 'employee/importEmployee',
    }),
    async importExcel(e) {
      const headerItem = {
        field: 'codeOld', label: 'Mã học sinh cũ', sortable: false, type: 'string',
      }
      if (this.selected) {
        this.table.fields.push(headerItem)
      }
      const { files } = e.target
      if (!files.length) {
        return
      } if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        // show err
      }
      if (files[0].name) {
        this.tenFile = files[0].name
      }
      this.readFile(files)
    },

    async readFile(files) {
      const file = files[0]
      if (!file) return

      try {
        const data = await new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => resolve(reader.result)
          reader.onerror = reject
          reader.readAsBinaryString(file)
        })

        const workbook = XLSX.read(data, { type: 'binary' })
        const sheetName = workbook.SheetNames[0]
        const rawData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 0, defval: '' })

        if (rawData.length === 0) {
          showErrorToast(this, 'File không có dữ liệu')
          return
        }

        const requiredHeaders = ['TEN', 'TAI_KHOAN', 'MA_KHOA', 'EMAIL', 'SO_DIEN_THOAI', 'LA_GIANG_VIEN']
        if (!requiredHeaders.every(header => rawData[0].hasOwnProperty(header))) {
          showErrorToast(this, 'File chưa đúng định dạng')
          return
        }

        this.dataExcel = rawData.map((item, index) => ({
          stt: index + 1,
          name: item.TEN,
          account: item.TAI_KHOAN,
          department: item.MA_KHOA,
          email: item.EMAIL,
          phone: item.SO_DIEN_THOAI,
          isTeacher: item.LA_GIANG_VIEN,
        }))

        this.table.items = this.dataExcel.slice(0, 10)
        this.totalRecords = this.dataExcel.length

        const duplicateAccounts = this.checkDuplicateAccount(this.dataExcel)
        this.disCreateAccount = duplicateAccounts.length > 0
        if (this.disCreateAccount) {
          showWarningToast(this, 'Account đang bị trùng, vui lòng kiểm tra lại dữ liệu trước khi import')
        }
      } catch (error) {
        alert(`Đọc file thất bại! ${error}`)
      } finally {
        this.resetInputFile()
      }
    },

    resetInputFile() {
      this.$refs.inputFileRef.reset()
    },

    async importData() {
      this.loading = true
      try {
        const data = this.dataExcel
        const res = await this.importEmployee(data)
        if (res.code === ApiCode.SUCCESS) {
          showSuccessToast(this, 'Lưu thành công')
          this.resetInputFile()
        } else {
          showErrorToast(this, res.message)
          this.resetInputFile()
        }
      } catch (e) {
        handleCatch(e)
      } finally {
        this.loading = false
      }
    },

    downloadFile() {
      const columns = [
        { index: 1, width: 130 },
        { index: 2, width: 130 },
        { index: 3, width: 130 },
        { index: 4, width: 130 },
        { index: 5, width: 100 },
        { index: 6, width: 130 },
      ]

      const headerStyle = {
        borders: { color: '#00000000', lineStyle: 'thin' },
        fontColor: '#ffffff',
        backColor: '#000000',
      }

      const headerCells = [
        { index: 1, value: 'TEN' },
        { index: 2, value: 'TAI_KHOAN' },
        { index: 3, value: 'EMAIL' },
        { index: 4, value: 'SO_DIEN_THOAI' },
        { index: 5, value: 'MA_KHOA' },
        { index: 6, value: 'LA_GIANG_VIEN' },
      ].map(cell => ({ ...cell, colSpan: 1, style: headerStyle }))

      const headerRow = { index: 1, cells: headerCells }
      const rows = [headerRow]
      const worksheets = [{ columns, rows }]
      const workbook = new Workbook({ worksheets }, 'xlsx')
      workbook.save('import_giang_vien.xlsx')
    },
    // handle even

    showToast(title, icon, variant, text) {
      if (variant === 'success') return showSuccessToast(this, title)
      if (variant === 'danger') return showErrorToast(this, title)
      if (variant === 'warning') return showWarningToast(this, title)
      return showInfoToast(this, title)
    },

    onPageChange(params) {
      const start = params.currentPerPage * (params.currentPage - 1)
      const end = this.dataExcel.length > (params.currentPerPage * params.currentPage) ? (params.currentPerPage * params.currentPage) : this.dataExcel.length
      this.table.items = this.dataExcel.slice(start, end)
    },

    onPerPageChange(params) {
      const start = params.currentPerPage * (params.currentPage - 1)
      const end = this.dataExcel.length > (params.currentPerPage * params.currentPage) ? (params.currentPerPage * params.currentPage) : this.dataExcel.length
      this.table.items = this.dataExcel.slice(start, end)
    },

    checkDuplicateAccount(arrays) {
      const accountSet = new Set()
      const duplicates = []
      for (const arr of arrays) {
        if (accountSet.has(arr.account)) {
          duplicates.push(arr)
        } else {
          accountSet.add(arr.account)
        }
      }

      return duplicates
    },

  },
}
</script>

<style type="text/css">
.form_file{
  width: auto !important;
}
</style>
